export const GENERIC_ERROR_MESSAGE = 'Something went wrong. Please try again.';
// Most likely EOAexport const genericErrorMessage = 'Something went wrong. Please try again.';
export const METHOD_NOT_SUPPORTED_ERROR_SUBSTRING =
  'this request method is not supported';
export const SEND_CALLS_NOT_SUPPORTED_ERROR = 'SEND_CALLS_NOT_SUPPORTED_ERROR';
export const TRANSACTION_TYPE_CALLS = 'TRANSACTION_TYPE_CALLS';
export const TRANSACTION_TYPE_CONTRACTS = 'TRANSACTION_TYPE_CONTRACTS';
